









































































































































































































































import BaseFilter from "@/components/Filter/BaseFilter";
import {DetailFilterParams} from "@/store/push/statistic/types";
import {Component, PropSync, Watch} from "vue-property-decorator";
import {DatePickerWings, FastDateDetailWings, FilterWings, SelectWings, NumberWings, FilterSelectedItemWings, InputWings} from "wings-ui-components";
import {beginningOfCurrentDay, currentDateEnd, dateFilter} from "@/utils/date-util";
import {Action, Getter, Mutation} from "vuex-class";
import {notifyError, notifySuccess, notifyWarning} from '@/utils/notify-helper';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {FilterWings, FastDateDetailWings, DatePickerWings, SelectWings, NumberWings, FilterSelectedItemWings, InputWings},
  filters: {dateFilter}
})
export default class PushDetailFilter extends BaseFilter<DetailFilterParams> {

  @PropSync("showAdditional") is_show_additional!: boolean;
  @PropSync("filterClone") propFilterClone!: DetailFilterParams;
  @PropSync("runFilter") propRunFilter!: boolean;

  @Mutation('setPushStatisticDetail') setStatistic: any

  @Action("getPushStatisticDetail") actionGetStatistic: any;
  @Action("exportPushStatisticDetail") actionExport: any;
  @Action("getPushApplications") actionGetPushApplications: any;
  @Action("getPushOS") actionGetPushOS: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("actionLog") actionLog: any;

  @Getter("pushApplications") applicationsList!: any[];
  @Getter("pushOS") pushOSList!: string[];
  @Getter("originators") originatorsList: any;
  @Getter("pushMessagesStatusList") statusList: any;
  @Getter("messageTypes") messageTypesList: any;

  defaultFilter(): DetailFilterParams {
    return new DetailFilterParams(beginningOfCurrentDay(), currentDateEnd());
  }

  created() {
    this.setStatistic(null)
    this.actionGetPushApplications();
    this.actionGetPushOS();
    this.actionGetMessageTypes();
    this.scroll()
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Detail statistics",
        addititionalInfo: getTranslatedParams(this.filter)
      }
      const resp = await this.actionGetStatistic(this.filter)
      await this.actionLog(this.logObject)
      if (resp.status === 204) {
        if (!nextPage) notifyWarning()
        this.is_last = true
      } else {
        this.is_last = false
      }
    } catch(error) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(error);
    } finally {
      this.moreLoading = false
    }
  }

  // Override
  async doActionExport() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Export",
        actionStatus: 'success',
        objectType: "Detail statistics",
        addititionalInfo: getTranslatedParams(this.filter)
      }
      await this.actionExport(this.sendFilter);
      await this.actionLog(this.logObject)
      notifySuccess(this.$t('dialog.export').toString());
    } catch(err) {
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
      notifyError(err);
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChange(val: DetailFilterParams) {
    this.propFilterClone = val;
  }

  @Watch('propRunFilter', {immediate: true})
  onRunFilterChange(val: boolean) {
    if (val) {
      this.filtered();
      this.propRunFilter = false;
    }
  }

}
